export const compareVersion = (v1, v2) => {
  if (typeof v1 !== 'string') return false;
  if (typeof v2 !== 'string') return false;
  const v1parts = v1.split('.').map((part) => Number.parseInt(part, 10));
  const v2parts = v2.split('.').map((part) => Number.parseInt(part, 10));
  const minLength = Math.min(v1.length, v2.length);
  for (let i = 0; i < minLength; ++i) {
    if (v1parts[i] > v2parts[i]) return 1;
    if (v1parts[i] < v2parts[i]) return -1;
  }
  if (v1parts.length === v2parts.length) {
    return 0;
  }
  return v1parts.length < v2parts.length ? -1 : 1;
};
